import './menu_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['open']
  static targets = ['elastic', 'unelastic']

  connect = (): void => {
    this.observe(this.elasticTargets, this.resizeElasticMenuSections)
    this.observe(this.unelasticTargets, this.markEmptyMenuSections)
  }

  resizeElasticMenuSections = (): void => {
    this.elasticTargets.forEach((section: HTMLElement) => {
      this.menuSectionController(section).resize(this.offset(section))
    })
  }

  markEmptyMenuSections = (): void => {
    this.allTargets.forEach((section: HTMLElement) => {
      this.menuSectionController(section).toggleEmpty()
    })
  }

  observe = (targets: HTMLElement[], callback: Function): void => {
    targets.forEach((section: HTMLElement) => {
      this.resizeObserver(callback).observe(section)
    })
  }

  resizeObserver = (callback: Function): ResizeObserver => {
    return new ResizeObserver(() => {
      callback()
    })
  }

  offset = (section: HTMLElement): number => {
    return this.unelasticTargetsWidth + this.elasticTargetsWidth - section.offsetWidth
  }

  menuSectionController = (section: HTMLElement): object => {
    return this.application.getControllerForElementAndIdentifier(section, 'menu-section')
  }

  open = (): void => {
    this.element.classList.add(this.openClass)
    this.resizeElasticMenuSections()
  }

  close = (): void => {
    this.element.classList.remove(this.openClass)
    this.resizeElasticMenuSections()
  }

  get allTargets (): HTMLElement[] {
    return this.unelasticTargets.concat(this.elasticTargets)
  }

  get unelasticTargetsWidth (): number {
    let width = 0
    this.unelasticTargets.forEach((unelasticSection: HTMLElement) => {
      width += unelasticSection.offsetWidth
    })
    return width
  }

  get elasticTargetsWidth (): number {
    let width = 0
    this.elasticTargets.forEach((elasticSection: HTMLElement) => {
      width += elasticSection.offsetWidth
    })
    return width
  }
}
